export default class PaymentCreditCard {
  public unitValue: number =  64.90;

  public description: string = '';

  public quantity: number = 0;

  public email: string = '';

  public REACT_APP_API_TOKEN: string = process.env.REACT_APP_API_TOKEN || '';

  public name: string = '';

  public expirationYear: string = '';

  public expirationMonth: string = '';

  public cardNumber: string = '';

  public cvv: string = '';

  public userTransactionId: string = '';

  public couponCode: string = '';

  constructor(data: any = {}) {
    this.unitValue = data.unit_value || 64.90;
    this.description = data.description || '';
    this.quantity = data.quantity || 1;
    this.email = data.email || '';
    this.REACT_APP_API_TOKEN = data.api_token || process.env.REACT_APP_API_TOKEN;
    this.name = data.name || '';
    this.expirationYear = data.expiration_year || '';
    this.expirationMonth = data.expiration_month || '';
    this.cardNumber = data.card_number || '';
    this.cvv = data.cvv || '';
    this.userTransactionId = data.user_transaction_id || '';
    this.couponCode = data.coupon_code || '';
  }

  public formatPayload() {
    return {
      description: this.description,
      email: this.email,
      api_token: this.REACT_APP_API_TOKEN,
      name: this.name,
      expiration_year: this.expirationYear,
      expiration_month: this.expirationMonth,
      card_number: this.cardNumber.replace(' ', ''),
      cvv: this.cvv,
      user_transaction_id: this.userTransactionId,
      coupon_code: this.couponCode,
    }
  }

  public stateToFormatPayload(paymentState: PaymentCreditCard) {
    return {
      description: paymentState.description,
      email: paymentState.email,
      name: paymentState.name,
      expiration_year: paymentState.expirationYear,
      expiration_month: paymentState.expirationMonth,
      card_number: paymentState.cardNumber.replace(' ', ''),
      cvv: paymentState.cvv,
      user_transaction_id: paymentState.userTransactionId,
      coupon_code: paymentState.couponCode,
    }
  }
}
